import useMessageService from '../../services/i18n/useMessageService';
import { getAllCountries } from '../../services/countryUtils';

/**
 * @typedef {object} CountriesList
 * @param {string} name
 * @param {string} phoneCode
 * @param {string} key
 */

const SEPARATOR = '@';

/**
 * A hook that returns countries with country codes and translated names
 *
 * @return {CountriesList[]}
 */
export default function useCountries() {
    const countryData = getAllCountries();
    const countryMessageKeys = countryData.map((country) => `countries.${country.key}`);
    const [countryNames] = useMessageService(countryMessageKeys);

    const countries = countryData.map(({ phoneCode, key }, index) => {
        const name = countryNames[index];
        return {
            key: `${phoneCode}${SEPARATOR}${key}`,
            phoneCode,
            name,
        };
    });

    return countries;
}
